import React__default from 'react';
import SanitizeHtml from '../SanitizeHtml/index.js';

// To get custom value for reback (landing page for example)
function getLabelValue(labelKey, locale, defaultLabel, labels) {
    if (labels) {
        for (var _i = 0, labels_1 = labels; _i < labels_1.length; _i++) {
            var label = labels_1[_i];
            if (label && label.key === labelKey) {
                var defaultValue = void 0;
                for (var _a = 0, _b = label.values; _a < _b.length; _a++) {
                    var value = _b[_a];
                    if (value.locale === locale) {
                        return value.value;
                    }
                    if (value.locale === "default") {
                        defaultValue = value.value;
                    }
                }
                if (defaultValue) {
                    return defaultValue;
                }
                break;
            }
        }
    }
    return defaultLabel;
}
// Return SanitizeHtml for custom value for reback (to display line break)
function getHtmlSanitizeValue(labelKey, locale, defaultLabel, labels, className, hideIfEmpty) {
    var html = getLabelValue(labelKey, locale, defaultLabel, labels);
    if ((html === undefined || html === "") && hideIfEmpty) {
        return React__default.createElement(React__default.Fragment, null);
    }
    return React__default.createElement(SanitizeHtml, { html: html, className: className });
}

export { getHtmlSanitizeValue, getLabelValue };
//# sourceMappingURL=utils.js.map
